import { KMenuItem } from 'app/services/utils/menu.service';
import { Location } from '@angular/common';
import {
  animate, Component, Input,
  OnChanges, OnInit,
  SimpleChanges, state, style, transition, trigger
} from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { MenuItem } from 'primeng/components/common/api';

@Component({
  selector: '[app-submenu]',
  templateUrl: 'submenu.html',
  animations: [
    trigger('children', [
      state('hidden', style({
        height: '0px'
      })),
      state('visible', style({
        height: '*'
      })),
      transition('visible => hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
      transition('hidden => visible', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ]
})
export class SubMenuComponent implements OnInit, OnChanges{


  @Input() item: KMenuItem;
  @Input() root: boolean;

  activeIndex: number;
  storedLabel: string = null;

  constructor(public router: Router, public location: Location, public srvLocalStorage: LocalStorageService) {}

  ngOnInit(): void {

    if (this.srvLocalStorage.get('koncentroMenuActive')) {
      this.storedLabel = this.srvLocalStorage.get('koncentroMenuActive')['label'];
      this.searchForActiveMenu();
    }

  }
  ngOnChanges(changes: SimpleChanges): void {
  }

  searchForActiveMenu() {
    let _i = -1;
    if (this.item && this.root) {
      for (let k in this.item) {
        if (this.item[k]['label'] == this.srvLocalStorage.get('koncentroMenuParent')['label'])
          this.activeIndex = parseInt(k);
      }
    }
  }

  itemClick(event: Event, item: KMenuItem, index: number){

    if(item.disabled) {
      event.preventDefault();
      return true;
    }

    this.activeIndex = (this.activeIndex === index) ? null : index;

    if (!this.root) {
      this.srvLocalStorage.set('koncentroMenuActive', item);
    }
    else
    {
      this.srvLocalStorage.set('koncentroMenuParent', item);
    }

    if (!item.url || item.routerLink) {
      event.preventDefault();
    }

    // if(item.command) {
    //   if(!item.eventEmitter) {
    //     item.eventEmitter = new EventEmitter();
    //     item.eventEmitter.subscribe(item.command);
    //   }
    //
    //   item.eventEmitter.emit({
    //     originalEvent: event,
    //     item: item
    //   });
    // }

    if(item.routerLink) {
      let storageUserData: any = null;
      if (item.targetBlank === true && item.link) {

        if (sessionStorage.getItem('userData')) {
          storageUserData = JSON.parse(sessionStorage.getItem('userData'));
        } else if (this.srvLocalStorage.get('userData')) {
          storageUserData = this.srvLocalStorage.get('userData');
        }

        const linkWithParams = item.link
          .replace('$access_token$', storageUserData.token)
          .replace('$companyId$', storageUserData.selectedCompany)
          .replace('$language$', storageUserData.language);

        window.open(linkWithParams, '_blank');

      } else {
        this.router.navigate(item.routerLink);
      }
    }
  }

  isActive(index: number): boolean {
    return this.activeIndex === index;
  }

  protected readonly JSON = JSON;
}



// WEBPACK FOOTER //
// ./src/app/views/submenu/submenu.component.ts